export enum SimEventPalette {
	One = "eventColor-1",
	Two = "eventColor-2",
	Three = "eventColor-3",
	Four = "eventColor-4",
	Five = "eventColor-5",
	Six = "eventColor-6",
	Seven = "eventColor-7",
	Eight = "eventColor-8",
}

/**
 * Maps numbers (i.e. enum keys) to hex values of user-defined colors (users can select colors for events, groups etc.)
 */
export const CustomColorMapping = {
	0: SimEventPalette.One,
	1: SimEventPalette.Two,
	2: SimEventPalette.Three,
	3: SimEventPalette.Four,
	4: SimEventPalette.Five,
	5: SimEventPalette.Six,
	6: SimEventPalette.Seven,
	7: SimEventPalette.Eight,
};
